import {Component, Input, OnChanges, OnInit, SimpleChanges, Inject} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {Locale, Region} from "@biletix/core/common"
import { RegionService } from '@biletix/core/services/region.service';
import {I18nService} from "@biletix/core/services/i18n.service";
import { EventsDetailByArtist } from '@biletix/core/models/event/events-detail-by-artist.model';
import { APP_BASE_HREF } from "@angular/common";

@Component({
    standalone: false,
    selector: 'btx-artist-list-item',
    templateUrl: './artist-list-item.component.html',
    styleUrls: ['./artist-list-item.component.scss']
})
export class ArtistListItemComponent implements OnInit, OnChanges {

    @Input() listItem!: EventsDetailByArtist;
    regions: Region[];
    currentRegion: string;
    locales: Locale[];
    currentLocale: Locale;
    currentLang: string;
    @Input() lang?: string;
    eventTitleInfo?: string;

    date: string | number | Date = new Date();
    firstDate: string | number | Date = new Date();
    lastDate: string | number | Date = new Date();

    timeFormat = "HH:mm"
    dayFormat = "d"
    monthFormat = "LLLL"

    statusText: string = '';

    constructor(private translateService: TranslateService,public region: RegionService,public i18n: I18nService,@Inject(APP_BASE_HREF) private baseHref: string) {
        this.locales = this.i18n.getAvailableLocales();
        this.currentLocale = this.i18n.currentLocale;
        this.currentLang = this.currentLocale.lang
        this.regions = this.region.getRegions();
        this.currentRegion = this.region.currentRegion.name;
    }

    ngOnInit(): void {
      this.eventTitleInfo = this.listItem.eventTitleInfo;
      this.date = this.listItem.performanceDate as Date;
      this.firstDate = this.listItem.firstPerformanceDate as Date;
      this.lastDate = this.listItem.lastPerformanceDate as Date;
      this.translateService.stream("performance.status." + this.listItem?.status).subscribe(text => {
        this.statusText = text;
      });
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.date = this.listItem.performanceDate as Date;
    }

    // performanceItemClasses() {
    //     return {
    //         'sold-out': !this.listItem.active
    //     }
    // }

    generateHref(eventCode?: string, region?: string, lang?: string, keyUrlText?: string): string {
      if (!eventCode || !region || !lang) {
        return ''; 
      }
      if (keyUrlText) {
        return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}/${keyUrlText}`;
      }
      return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}`;
    }

    statusClasses() {
        return {
            success: this.listItem.status === "s01_onsale",
            'status-sold-out': this.listItem.status === "s02_soldout",
            'status-soon': this.listItem.status === "s03_soon",
            'status-canceled': this.listItem.status === "s04_canceled",
            'status-postponed': this.listItem.status === "s05_postponed",
            'status-boxoffice': this.listItem.status === "s06_boxoffice",
            'status-otherchannelwbox': this.listItem.status === "s15_other_channel_list_with_boxoffice",
            'status-checkback': this.listItem.status === "s12_check_back_later",
            'status-oldover': this.listItem.status === "s13_old_over",
            'status-other': this.listItem.status === "s14_other_channels"
        }
    }
}
